<template>
  <div>
    <h1 class="display-3">Kolekcja osobista <br/>śp. Janusza Bohdanowicza</h1><br/>
    <p>
      W 2009 roku Archiwum Ośrodka KARTA otrzymało w darze kolekcję osobistą Janusza Bohdanowicza pseud. „Czortek”.
      Wśród materiałów przekazanych do Archiwum Ośrodka KARTA znajdują się teczki osobowe byłych żołnierzy Armii Krajowej
      Okręgu Wileńskiego (m.in. por. Wilhelma Tupikowskiego i Aleksandra Alesionka), a także dokumentacja dotycząca działalności
      Brygad Armii Krajowej Okręgu Wileńskiego, m.in. 3. Brygady „Szczerbca”, 6. Wileńskiej Samodzielnej Brygady
      Partyzanckiej AK oraz 7. Brygady Armii Krajowej „Wilhelma” Okręgu Wileńskiego, w tym: arkusze ewidencji przebiegu służby,
      relacje i wspomnienia żołnierzy dotyczące ich wojennych losów np. udziału brygady w ochronie sztabu Armii Krajowej Okręg Wilno,
      ataku na Troki czy na bunkry wojska litewskiego, korespondencja prywatna dotycząca wydarzeń wojennych, rozkazy dzienne,
      zaświadczenia o działalności antysowieckiej, protokoły przesłuchań, wyroki skazujące na karę pozbawienia wolności za
      działalność antypaństwową z czasów PRL, karty zwolnienia z więzienia. Kolekcja zawiera także bogatą dokumentację
      działalności środowiska 7. Brygady Żołnierzy AK: statut, akty darowizny, opisy prowadzonych akcji pomocy ludności
      polskiej na Wileńszczyźnie.
    </p>

    <p>
      Kolekcja osobista śp. Janusza Bohdanowicza jest udostępniana bezpłatnie w czytelni Ośrodka KARTA
      (ul. Narbutta 29, Warszawa, e-mail: archiwum@karta.org.pl) od poniedziałku do środy w godz. 9.30-16.30.
      Przed wizytą w archiwum zachęcamy Państwa do zapoznania się z
      <a href="./kolekcja/Inwentarz_Kolekcji_Janusza_Bohdanowicza.pdf" target="_blank">Inwentarzem Kolekcji.</a>
    </p>

    <p>
      Część materiałów archiwalnych z kolekcji osobistej śp. Janusza Bohdanowicza została zdigitalizowana i
      jest udostępniana bezpłatnie na stronie Biblioteki Cyfrowej Ośrodka KARTA.
      <a href="http://dlibra.karta.org.pl/dlibra/collectiondescription?dirids=1272" target="_blank">
          Zapraszamy Państwa do odwiedzenia strony dLibra.karta.org.pl.
      </a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'kontakt',
  metaInfo:{
    title: 'Kolekcja osobista śp. Janusza Bohdanowicza',
    meta:[
      {name: 'description', content: 'W 2009 roku Archiwum Ośrodka KARTA otrzymało w darze kolekcję osobistą Janusza Bohdanowicza pseud. „Czortek”. Wśród materiałów przekazanych do Archiwum Ośrodka KARTA znajdują się teczki osobowe byłych żołnierzy Armii Krajowej Okręgu Wileńskiego...' },
      {name: 'og:url', content: 'http://akwilno.pl/kolekcja' },
      {name: 'og:title', content: 'Kolekcja osobista śp. Janusza Bohdanowicza' },
      {name: 'og:image', content: '/main/menu_logo.png' },
      {name: 'og:description', content: 'W 2009 roku Archiwum Ośrodka KARTA otrzymało w darze kolekcję osobistą Janusza Bohdanowicza pseud. „Czortek”. Wśród materiałów przekazanych do Archiwum Ośrodka KARTA znajdują się teczki osobowe byłych żołnierzy Armii Krajowej Okręgu Wileńskiego...' },
      {name: 'twitter:url', content: 'http://akwilno.pl/kolekcja' },
      {name: 'twitter:title', content: 'Kolekcja osobista śp. Janusza Bohdanowicza' },
      {name: 'witter:image', content: '/main/menu_logo.png' },
      {name: 'twitter:description', content: 'W 2009 roku Archiwum Ośrodka KARTA otrzymało w darze kolekcję osobistą Janusza Bohdanowicza pseud. „Czortek”. Wśród materiałów przekazanych do Archiwum Ośrodka KARTA znajdują się teczki osobowe byłych żołnierzy Armii Krajowej Okręgu Wileńskiego...' }
    ]
  }
}
</script>



// WEBPACK FOOTER //
// src/components/kolekcja.vue